module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-set"
  }, [_c('div', {
    staticClass: "sub"
  }, [_c('el-select', {
    staticClass: "sub-select",
    attrs: {
      "disabled": _vm.step > 1,
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.subSiteChange
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.subSiteId,
      attrs: {
        "label": item.subSiteName,
        "value": item.subSiteId
      }
    })
  })), _vm._v(" "), (!_vm.value) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'substationSet',
        query: {
          sid: -1
        }
      }
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.step > 1
    }
  }, [_vm._v("添加新子站")])], 1) : _vm._e(), _vm._v(" "), (!_vm.value) ? _c('div', {
    staticClass: "mind"
  }, [_vm._v("请选择子站或添加新子站！")]) : _c('div', [_c('div', {
    staticClass: "set-step white-box"
  }, [_c('ul', {
    staticClass: "xmly-step"
  }, [_c('li', {
    class: ("item step1 " + (_vm.step>=1 && 'on'))
  }, [_c('span', {
    staticClass: "dot"
  }), _vm._v("设置显示模块")]), _vm._v(" "), _c('li', {
    class: ("item step2 " + (_vm.step>=2 && 'on'))
  }, [_c('span', {
    staticClass: "dot"
  }), _vm._v("配置模块展示内容")]), _vm._v(" "), _c('li', {
    class: ("item step3 " + (_vm.step==3 && 'on'))
  }, [_c('span', {
    staticClass: "dot"
  }), _vm._v("预览和发布")])])]), _vm._v(" "), (_vm.step === 1) ? _c('div', {
    staticClass: "set-main"
  }, [_c('div', {
    staticClass: "home-page-pre"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("首页预览")]), _vm._v(" "), _c('iframe', {
    staticClass: "homePreview",
    attrs: {
      "name": "homePreview",
      "src": ("" + _vm.PROTOCOL + _vm.SUB_SITE_HOST + "/index/" + (_vm.value>0 ? _vm.value:_vm.SUB_PREVIEW_ID) + "?preview=1")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "show-component"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("展示组件")]), _vm._v(" "), _c('div', {
    staticClass: "components-choose"
  }, [_c('p', [_vm._v("手机端只展示开启状态的组件")]), _vm._v(" "), _vm._l((_vm.componentsChoose), function(item, index) {
    return _c('div', {
      staticClass: "components-radios"
    }, [_c('span', [_vm._v(_vm._s(item.txt))]), _vm._v(" "), _c('el-radio-group', {
      on: {
        "change": function($event) {
          _vm.homeSendMessage(item.key, _vm.componentsChoose[index].value)
        }
      },
      model: {
        value: (_vm.componentsChoose[index].value),
        callback: function($$v) {
          _vm.$set(_vm.componentsChoose[index], "value", $$v)
        },
        expression: "componentsChoose[index].value"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": 1
      }
    }, [_vm._v("开启")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": 0
      }
    }, [_vm._v("关闭")])], 1)], 1)
  })], 2)])]) : (_vm.step === 2) ? _c('div', {
    staticClass: "set-main"
  }, [(_vm.componentsChoose[0].value) ? _c('div', {
    staticClass: "carousel"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("轮播图片")]), _vm._v(" "), _c('div', {
    staticClass: "add column-content"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addPicLoading
    },
    on: {
      "click": _vm.chooseFile
    }
  }, [_vm._v("添加图片")]), _vm._v(" "), _c('input', {
    staticClass: "file-upload",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.submitFile
    }
  }), _vm._v(" "), _c('span', [_vm._v("最多添加5张广告图片（图片尺寸：750x330）")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.carousels,
      "row-class-name": "carousel-table-tr"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "82"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "picture",
      "label": "图片",
      "width": "188"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "column-content carousel-img"
        }, [_c('img', {
          staticClass: "img",
          attrs: {
            "src": scope.row.imgUrl
          }
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "链接地址",
      "width": "276"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_c('el-select', {
          staticClass: "carousel-select-address",
          attrs: {
            "placeholder": "请选择"
          },
          on: {
            "change": _vm.changeContentType
          },
          model: {
            value: (scope.row.contentType),
            callback: function($$v) {
              _vm.$set(scope.row, "contentType", $$v)
            },
            expression: "scope.row.contentType"
          }
        }, _vm._l((_vm.urlAddress), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }))], 1), _vm._v(" "), _c('div', {
          staticClass: "add-address"
        }, [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!!(scope.row.contentType == 3 ? scope.row.contentUrl : (scope.row.contentType == 2 ? scope.row.contentColumnName : scope.row.contentVoiceName))),
            expression: "!!(scope.row.contentType==3 ? scope.row.contentUrl : (scope.row.contentType==2 ? scope.row.contentColumnName : scope.row.contentVoiceName))"
          }],
          staticClass: "address-input"
        }, [_vm._v(_vm._s(scope.row.contentType == 3 ? scope.row.contentUrl : (scope.row.contentType == 2 ? scope.row.contentColumnName : scope.row.contentVoiceName)))]), _vm._v(" "), (scope.row.contentType == 2) ? _c('el-button', {
          staticClass: "carousel-select-column",
          on: {
            "click": function($event) {
              _vm.addContentVisible = true;
              _vm.carouselContentIndex = scope.$index;
              _vm.changeContentType(2);
            }
          }
        }, [_vm._v("\n                    " + _vm._s(scope.row.contentColumnName ? '更改' : '选择专辑') + "\n                  ")]) : _vm._e(), _vm._v(" "), (scope.row.contentType == 1) ? _c('el-button', {
          staticClass: "carousel-select-voice",
          on: {
            "click": function($event) {
              _vm.addContentVisible = true;
              _vm.carouselContentIndex = scope.$index;
              _vm.changeContentType(1);
            }
          }
        }, [_vm._v("\n                    " + _vm._s(scope.row.contentVoiceName ? '更改' : '选择声音') + "\n                  ")]) : _vm._e(), _vm._v(" "), (scope.row.contentType == 3) ? _c('el-button', {
          staticClass: "carousel-select-address",
          on: {
            "click": function($event) {
              _vm.inputAddress(scope.$index)
            }
          }
        }, [_vm._v(_vm._s(scope.row.contentUrl ? '更改' : '输入地址') + "\n                  ")]) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "198"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "move-operate"
        }, [(scope.$index > 0) ? _c('span', {
          staticClass: "orange",
          on: {
            "click": function($event) {
              _vm.carChangePos(_vm.carousels, scope.$index, -1)
            }
          }
        }, [_vm._v("上移")]) : _vm._e(), _vm._v(" "), (scope.$index < _vm.carousels.length - 1) ? _c('span', {
          staticClass: "orange",
          on: {
            "click": function($event) {
              _vm.carChangePos(_vm.carousels, scope.$index, 1)
            }
          }
        }, [_vm._v("下移")]) : _vm._e(), _vm._v(" "), _c('span', {
          staticClass: "orange",
          on: {
            "click": function($event) {
              _vm.carChangePos(_vm.carousels, scope.$index, 0)
            }
          }
        }, [_vm._v("删除")])])]
      }
    }])
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.componentsChoose[2].value) ? _c('div', {
    staticClass: "classify-set"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("专栏橱窗设置")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "add column-content"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addClassifyData
    }
  }, [_vm._v("添加专栏")]), _vm._v(" "), _c('span', [_vm._v("最多添加10个专栏")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.categorys,
      "row-class-name": "classify-table-tr"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "97"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "classify",
      "label": "专栏",
      "width": "214"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticClass: "classify-select",
          attrs: {
            "placeholder": "请选择"
          },
          on: {
            "change": function($event) {
              _vm.switchCategory(scope.row.categoryId, scope.row.subSiteDisplayName)
            }
          },
          model: {
            value: (scope.row.categoryId),
            callback: function($$v) {
              _vm.$set(scope.row, "categoryId", $$v)
            },
            expression: "scope.row.categoryId"
          }
        }, _vm._l((_vm.classifySelect), function(item) {
          return _c('el-option', {
            key: item.categoryId,
            attrs: {
              "label": item.category,
              "value": item.categoryId
            }
          })
        }))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "专栏显示名称（最多四个字）",
      "width": "194"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticClass: "sub-show-name",
          attrs: {
            "maxlength": 4
          },
          model: {
            value: (scope.row.subSiteDisplayName),
            callback: function($$v) {
              _vm.$set(scope.row, "subSiteDisplayName", $$v)
            },
            expression: "scope.row.subSiteDisplayName"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "239"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "move-operate"
        }, [(scope.$index > 0) ? _c('span', {
          staticClass: "orange",
          on: {
            "click": function($event) {
              _vm.carChangePos(_vm.categorys, scope.$index, -1)
            }
          }
        }, [_vm._v("上移")]) : _vm._e(), _vm._v(" "), (scope.$index < _vm.categorys.length - 1) ? _c('span', {
          staticClass: "orange",
          on: {
            "click": function($event) {
              _vm.carChangePos(_vm.categorys, scope.$index, 1)
            }
          }
        }, [_vm._v("下移")]) : _vm._e(), _vm._v(" "), _c('span', {
          staticClass: "orange",
          on: {
            "click": function($event) {
              _vm.carChangePos(_vm.categorys, scope.$index, 0)
            }
          }
        }, [_vm._v("删除")]), _vm._v(" "), _c('span', {
          staticClass: "orange cateManage",
          attrs: {
            "data-id": scope.row.id,
            "data-cateId": scope.row.categoryId,
            "data-name": scope.row.subSiteDisplayName,
            "data-order": scope.row.serialNumber
          },
          on: {
            "click": _vm.specialManage
          }
        }, [_vm._v("专栏管理")])])]
      }
    }])
  })], 1)], 1)]) : _vm._e()]) : _c('div', {
    class: 'set-main' + ' ' + (_vm.value <= 0 ? 'NoneOnline' : '')
  }, [(_vm.value > 0) ? _c('div', {
    staticClass: "online-page-pre"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("线上")]), _vm._v(" "), _c('iframe', {
    staticClass: "onlinePreview",
    attrs: {
      "name": "onlinePreview",
      "src": ("" + _vm.PROTOCOL + _vm.SUB_SITE_HOST + "/index/" + (_vm.value>0 ? _vm.value:_vm.SUB_PREVIEW_ID) + "?preview=1")
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "current-page-pre"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("当前")]), _vm._v(" "), _c('iframe', {
    staticClass: "currPreview",
    attrs: {
      "name": "currPreview",
      "src": ("" + _vm.PROTOCOL + _vm.SUB_SITE_HOST + "/index/" + (_vm.value>0 ? _vm.value:_vm.SUB_PREVIEW_ID) + "?preview=1")
    }
  })])]), _vm._v(" "), (_vm.step == 3) ? _c('div', {
    staticClass: "set-main column-content add-sub-name white-box"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("子站名称")]), _vm._v(" "), _c('el-input', {
    staticClass: "subStation-name",
    model: {
      value: (_vm.subSiteName),
      callback: function($$v) {
        _vm.subSiteName = $$v
      },
      expression: "subSiteName"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "set-main bottom-operate column-content"
  }, [_c('el-button', {
    staticClass: "quit-set",
    on: {
      "click": _vm.quit
    }
  }, [_vm._v("退出设置")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step >= 2),
      expression: "step>=2"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.changeStep(-1)
      }
    }
  }, [_vm._v("上一步")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step < 3),
      expression: "step<3"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.changeStep(1)
      }
    }
  }, [_vm._v("下一步")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 3),
      expression: "step==3"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("发布")])], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "custom-class": "el-dialog-album-stick",
      "visible": _vm.categoryAlbumVisible,
      "top": "5%",
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.categoryAlbumVisible = $event
      },
      "close": _vm.albumStickReset
    }
  }, [_c('el-transfer', {
    directives: [{
      name: "loading",
      rawName: "v-loading.lock",
      value: (_vm.searching),
      expression: "searching",
      modifiers: {
        "lock": true
      }
    }],
    attrs: {
      "titles": ['专辑库', '首页专栏显示专辑'],
      "data": _vm.searchAlbumList,
      "props": {
        key: 'contentId',
        label: 'contentName'
      },
      "button-texts": ['删除', '添加'],
      "filterable": "",
      "footer-format": {
        noChecked: '${total} / 6',
        hasChecked: '已选 ${checked} 项'
      },
      "render-content": _vm.transferRender
    },
    on: {
      "change": _vm.upUserAlbumList
    },
    model: {
      value: (_vm.userAlbumIdList),
      callback: function($$v) {
        _vm.userAlbumIdList = $$v
      },
      expression: "userAlbumIdList"
    }
  }), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveCategory
    }
  }, [_vm._v("保存设置")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加内容",
      "visible": _vm.addContentVisible,
      "size": "add-content"
    },
    on: {
      "update:visible": function($event) {
        _vm.addContentVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "add-content-header"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("关键字")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "model": _vm.addContentForm,
      "onsubmit": "return false;"
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "请输入关键字"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.addContent($event)
      }
    },
    model: {
      value: (_vm.addContentForm.searchKeyword),
      callback: function($$v) {
        _vm.$set(_vm.addContentForm, "searchKeyword", $$v)
      },
      expression: "addContentForm.searchKeyword"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addContentSearchLoading
    },
    on: {
      "click": _vm.addContent
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "show_result"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.radioValue),
      callback: function($$v) {
        _vm.radioValue = $$v
      },
      expression: "radioValue"
    }
  }, _vm._l((_vm.contentResult.list), function(radio) {
    return _c('el-radio', {
      key: radio.contentId,
      staticClass: "classify-radio column-content",
      attrs: {
        "label": radio.contentId
      }
    }, [_c('span', {
      staticClass: "column-content"
    }, [_c('img', {
      staticClass: "column-img",
      attrs: {
        "src": radio.contentCover
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "column-name",
      attrs: {
        "title": radio.contentName
      }
    }, [_vm._v(_vm._s(radio.contentName))])])])
  })), _vm._v(" "), (_vm.contentResult.list && _vm.contentResult.list.length === 0) ? _c('div', [_vm._v("暂无搜索到匹配内容")]) : _vm._e()], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.addContentForm.curPage,
      "page-sizes": [10, 20, 30, 40],
      "page-size": _vm.addContentForm.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.contentResult.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.$set(_vm.addContentForm, "curPage", $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.chooseContent
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.addContentVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fff54ed","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/subStation/subSet.vue
// module id = 925
// module chunks = 1